var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityLock = function SvgSecurityLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "#00b2d2"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3c-3.844 0-7 3.156-7 7v3H6v16h20V13h-3v-3c0-3.844-3.156-7-7-7Zm0 2c2.754 0 5 2.246 5 5v3H11v-3c0-2.754 2.246-5 5-5ZM8 15h16v12H8Z"
  })));
};
export default SvgSecurityLock;